<template>
	<div class="row result">
		<div class="col-xl-12">
			<div class="m-portlet  m-portlet--bordered-semi   m-portlet--full-height  m-portlet--rounded">
				<div class="m-portlet__head m--padding-top-20">
					<div class="m-portlet__head-caption">
						<div class="m-portlet__head-title">
							<h3 class="m-portlet__head-text">
								Phân tích kết quả
							</h3>
						</div>
					</div>
				</div>
				<div class="m-portlet__body m-portlet__body--no-padding">
					<ul class="nav nav-tabs nav-fill game" role="tablist">
						<li class="nav-item">
							<a gId="2" v-on:click="tabChange" class="nav-link active" data-toggle="tab">Nam</a>
						</li>
						<li class="nav-item">
							<a gId="4" v-on:click="tabChange" class="nav-link" data-toggle="tab">Trung</a>
						</li>
						<li class="nav-item">
							<a gId="1" v-on:click="tabChange" class="nav-link" data-toggle="tab">Bắc</a>
						</li>
					</ul>
					<div class="tab-content">	
						<div class="row justify-content-md-center">
								<div class="btn-group m-btn-group" role="group" aria-label="...">
									<button type="button" class="btn btn-primary" v-on:click="crawler">1. Crawler</button>
									<button type="button" class="btn btn-primary" v-on:click="compare">2. Compare</button>
									<button type="button" class="btn btn-primary" v-on:click="insert">3. Insert</button>
									<button type="button" class="btn btn-primary" v-on:click="analysis">4. Analysis</button>
								</div>
						</div>
						<div class="row m-row--col-separator-xl">
							<div class="col-md-12 col-lg-6 col-xl-6" v-for="(kqxs, web) in this.kqxss">
								<div class="m-widget1">
									<div class="m-stack m-stack--ver m-stack--desktop">
										<div class="m-stack__item m-stack__item--left m-stack__item--middle">
											<h3 class="m--font-info">{{web}}</h3>
										</div>
										<div class="m-stack__item m-stack__item--center m-stack__item--middle">
											<span class="m-switch m-switch--icon m-switch--accent">
												<label>
													<input type="checkbox" :name="web" v-model="chose[web]">
													<span></span>
												</label>
											</span>
										</div>
									</div>
									<div class="m--space-20"></div>
									<table width="100%" border="0" cellspacing="0" cellpadding="0">
										<tbody>
											<tr>
												<td v-for="(kq_all, dai, index) in kqxs">
													<table width="100%">
														<tbody>
															<tr>
																<td class="channel" colspan="2">
																	{{gameInfo.channels[dai].alias}}
																</td>
															</tr>
															<tr v-for="(kqs,giai) in kq_all">
																<td v-if="index == 0">
																	{{giai.split("-")[1]}}
																</td>
																<td v-else></td>
																<td>
																	<div v-if="(game == 1 && giai == 'giai-nhi') || (game == 1 && giai == 'giai-tu')">
																		<input :kqId="dai+giai+k" v-for="(kq, k) in kqs" class="form-control m-input motphanhai" type="text" placeholder="null" v-model="kqxss[web][dai][giai][k]">
																	</div>
																	<div v-else-if="(game == 1 && giai == 'giai-ba') || (game == 1 && giai == 'giai-nam') || (game == 1 && giai == 'giai-sau')">
																		<input :kqId="dai+giai+k" v-for="(kq, k) in kqs" class="form-control m-input motphanba" type="text" placeholder="null" v-model="kqxss[web][dai][giai][k]">
																	</div>
																	<div v-else-if="game == 1 && giai == 'giai-bay'">
																		<input :kqId="dai+giai+k" v-for="(kq, k) in kqs" class="form-control m-input motphantu" type="text" placeholder="null" v-model="kqxss[web][dai][giai][k]">
																	</div>
																	<div v-else>
																		<input :kqId="dai+giai+k" v-for="(kq, k) in kqs" class="form-control m-input" type="text" placeholder="null" v-model="kqxss[web][dai][giai][k]">
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css">
	.result .channel{
		text-align: center;
		color: #5867dd;
	}
	.result .form-control{    
		height: 22px;
    float: left;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
	}
	.result .form-control[readonly], 
	.result .form-control{
		border-color: white !important;
	}
	.result .form-control.focus, 
	.result .form-control:focus{
		border-color: white;
		outline: none;
	}
	.result  tr{
		border-bottom: 1px solid;
	}
	.motphanhai{
		width: 50%;
	}
	.motphanba{
		width: 33%;
	}
	.motphantu{
		width: 25%;
	}
</style>
<script>
	import { mapGetters } from 'vuex';

	export default {
		props: ['data'],

		data(){
	      return {
	      	"game": "2",
          	"kqxss": [],
          	"chose": [],
          // "minhngoc": [],
          // "minhchinh": []
        }
	    },
    	computed: {
			...mapGetters({
		  		gameInfo: 'gameInfo'
			})
		},
		methods: {
			tabChange: function(e){
				this.kqxss = [];
				this.game = $(e.currentTarget).attr("gId");
			},
			crawler: function(){
      	let vm = this;
      	window.axios.get("admin-panel/tools/kqxs?game="+this.game)
      				.then((res) => {
      					res = res.data;
      					vm.kqxss = res.data;
      				})
      				.catch((error) => {

      				});
			},
			compare: function(){
				var smn = JSON.stringify(this.kqxss.minhngoc);
				var smc = JSON.stringify(this.kqxss.minhchinh);
				var compare = smn.localeCompare(smc);
				if(compare === 0){
					$(".result input").attr("style", "color:blue");
					swal("Giống y đúc");
				}else{
					swal("Khác ròi");

					$(".result input").each(function( index ) {
						var at = $(this).attr('kqid');
						var vv = $(".result input[kqid="+at+"]");
					    if($(vv[0]).val() != $(vv[1]).val()){
					        $(vv).attr("style", "color:red");
					    }
					});
				}
			},
			insert: function(){
				if(this.chose.minhngoc == true || this.chose.minhchinh == true){
					var kqxs = this.chose.minhngoc ? this.kqxss.minhngoc : this.kqxss.minhchinh;
					window.axios.post("admin-panel/tools/kqxs", {
        		kqxs: kqxs,
        		game: this.game
        	})
			    .then((response) => {
			    	if(response.data.code == 0){
			    		swal("", "Thêm thành công", "success");
			    	}else{
			    		swal("", "Debug thôi, lỗi rồi", "error");
			    	}
			    })
			    .catch((error) => { });
				}else{
					swal("Hãy chọn trang lấy dữ liệu");
				}
			},
			analysis: function(){
      	window.axios.get("admin-panel/tools/analysis?game="+this.game)
      				.then((response) => {
					    	if(response.data.code == 0){
					    		swal("", response.data.data.totel_bet + ": bet. " + response.data.data.totel_money + ": money", "success");
					    	}else{
					    		swal("", "Debug thôi, lỗi rồi " + response.data.data.code + " " + response.data.data.msg, "error");
					    	}
      				})
      				.catch((error) => {
					    		swal("", "Debug thôi, lỗi rồi", "error");
      				});
			}
	  }
	}
</script>